/**
 * Módulo: Reportes (reportes congelados de los dashboards — wave 1, 8-oct-2026)
 *
 * Ítem CONTRATABLE del plan (decisión de Mariano, triage 10-oct-2026, pregunta
 * 39: «Reportes se incluye o excluye por plan»). Un plan lo incluye —o no— en
 * `modulosIncluidos`, y `sincronizarModulosPlan` lo denormaliza a
 * `empresas.modulosDisponibles`. Dictamen del comité del 21-oct sobre cómo.
 *
 * El id NO es `reportes`: ese código ya es del catálogo de permisos (la página
 * /reportes de Gestión, `src/core/lib/modulos.js`), y los ids del registry y
 * los códigos del catálogo comparten espacio de nombres. `reportes-generados`
 * es el nombre de la colección y de la solapa de la ficha (`tabsEmpresa.js`).
 *
 * `permisoModulos: ['dashboards']` porque es el permiso con el que hoy se ven
 * los reportes en el portal: `useModulosVisibles` sólo incluye un módulo si el
 * rol tiene alguno de sus `permisoModulos`, así que con `[]` el módulo no sería
 * visible para nadie y no se lo podría gatear por plan en el portal.
 *
 * Sin rutas ni menú propios: la superficie (botón Generar en los dashboards,
 * solapas de la ficha, página del portal) ya existe y vive en otros módulos.
 * Que esos puntos de entrada respeten el plan —generar con `moduloOperablePor`,
 * ver con la visibilidad de la empresa— es la segunda parte del cambio; hasta
 * que entre, el casillero de Planes existe para que los planes lo incluyan
 * ANTES de que el gate fail-closed de generar deje sin reportes a una empresa
 * cuyo plan no lo tiene.
 *
 * Rules: NO se tocan. La escritura de `reportesGenerados` es sólo staff, así
 * que el tenant nunca produce un reporte: el plan es un control COMERCIAL sobre
 * un escritor de confianza (molde `mercado-datos`), no un candado de datos. Un
 * cliente cuyo plan excluya Reportes sigue pudiendo leer lo que ya se le
 * publicó.
 */
export default {
  id: 'reportes-generados',
  nombre: 'Reportes',
  descripcion: 'Reportes congelados de los dashboards: generarlos para la empresa y publicarlos en su portal.',
  icono: 'file-text',
  tipo: 'operativo',
  version: '0.1.0',

  routes: [],
  menuItems: [],

  features: ['reportes-congelados'],

  permisoModulos: ['dashboards'],
}
